export const awards = {
	title: "Awards",
	description: "Select the products and discounts that the customer will be entitled to.",
	maxUses: {
		label: "Maximum number of uses per gain",
		info: "How many times the promotion can be applied in the same purchase.",
		withoutLimits: "No Boundaries",
	},
	discountType: {
		label: "Discount type",
		percentage: "Percentage",
		percentageInfo: "Discount percentage applied to the product value.",
		value: "Value",
		error: "The following products are worth less than the discount given",
		table: {
			product: "Product",
			price: "Sale value",
			promotionalPrice: "Promotional value",
			error: "Maximum and minimum value does not match",
			empty: {
				label: "No products selected",
				description:
					"If you do not select products, the promotion will work on all products.",
			},
			total: "Total of {{count}} product(s)",
			addProduct: "add product",
			add: "Add products",
		},
	},
};
